module.exports = __webpack_public_path__ + "static/img/xz.deb281d2.png";